module.exports = __webpack_public_path__ + "static/img/24.032470b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/hearthstone/ranks/24.png
// module id = Suev
// module chunks = 35